import { useStoreSelector } from "components/hooks/useStoreSelector";
import { usePilotAssignmentStoreContext } from "./usePilotAssignmentStoreContext";

export const useHasEditableChanged = () => {
    const storeContext = usePilotAssignmentStoreContext();
    return useStoreSelector(storeContext, (state) => state.hasEditableChanged);
}

export const useSetHasEditableChanged = () => {
    const storeContext = usePilotAssignmentStoreContext();
    const setHasEditableChanged = useStoreSelector(storeContext, (state) => state.setHasEditableChanged);

    return () => {
        setHasEditableChanged(true);
        setTimeout(() => {
            setHasEditableChanged(false);
        }, 5);
    }
}
